import { render, staticRenderFns } from "./discussions-status-changer.vue?vue&type=template&id=2e70cec4"
import script from "./discussions-status-changer.vue?vue&type=script&lang=js"
export * from "./discussions-status-changer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports